import styled from 'styled-components';
import { colors } from '@keen.io/colors';
import { transparentize } from 'polished';
export var Container = styled.div.withConfig({
  displayName: "Intervalstyles__Container",
  componentId: "keen-query-creator__sc-1f1zkmj-0"
})(["&&&{position:relative;}"]);
export var TitleWrapper = styled.div.withConfig({
  displayName: "Intervalstyles__TitleWrapper",
  componentId: "keen-query-creator__sc-1f1zkmj-1"
})(["&&&{display:flex;align-items:center;}"]);
export var IntervalContainer = styled.div.withConfig({
  displayName: "Intervalstyles__IntervalContainer",
  componentId: "keen-query-creator__sc-1f1zkmj-2"
})(["&&&{position:relative;width:150px;margin-right:10px;}"]);
export var DropdownContainer = styled.div.withConfig({
  displayName: "Intervalstyles__DropdownContainer",
  componentId: "keen-query-creator__sc-1f1zkmj-3"
})(["&&&{border-top:solid 1px ", ";}"], colors.white[300]);
export var TooltipIconContainer = styled.div.withConfig({
  displayName: "Intervalstyles__TooltipIconContainer",
  componentId: "keen-query-creator__sc-1f1zkmj-4"
})(["&&&{display:inline-block;margin-left:5px;position:relative;cursor:pointer;}"]);
export var IntervalManagement = styled.div.withConfig({
  displayName: "Intervalstyles__IntervalManagement",
  componentId: "keen-query-creator__sc-1f1zkmj-5"
})(["&&&{display:flex;}"]);
export var StyledPlaceholder = styled.div.withConfig({
  displayName: "Intervalstyles__StyledPlaceholder",
  componentId: "keen-query-creator__sc-1f1zkmj-6"
})(["&&&{color:", ";text-align:center;width:100%;}"], transparentize(0.5, colors.black[300]));
export var TextCenter = styled.div.withConfig({
  displayName: "Intervalstyles__TextCenter",
  componentId: "keen-query-creator__sc-1f1zkmj-7"
})(["&&&{text-align:center;flex:1;}"]);